import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { JwtService } from '../services/jwt.service';
import { Paths } from '../constants/path.constants';

export const authGuard: CanActivateFn = (route, state) => {
  const jwtService = inject(JwtService);
  const router = inject(Router);

  const isLoggedIn = jwtService.isUserLoggedIn();

  if (isLoggedIn) {
    return router.navigate([Paths.EMPTY]);
  }

  return true;
};
